import type { TranslationContextValue } from '@paintscout/ui'

const STRUCTURED_WORK_ORDER_LABELS = [
  '# of coats:',
  'Application:',
  'Additional Work Products:',
  'Materials:',
  'Colour:',
  'Color:',
  'Primer:',
  'Coats:',
  'Labor:',
  'Hours:',
  'Notes:',
  'Paint:',
  'Prep:'
] as const

export function translateStructuredWorkOrderContent(
  content: string | null | undefined,
  __: TranslationContextValue['__']
) {
  if (!content) return content ?? ''

  return STRUCTURED_WORK_ORDER_LABELS.reduce((translated, label) => {
    return translated.split(label).join(__(label))
  }, content)
}
